const { makeStyles } = require('@material-ui/core');

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1
  },
  searchBox: {
    borderRadius: '1.25rem',
    backgroundColor: '#FFFFFF',
    overflow: 'hidden'
  },
  searchInput: {
    height: '40px',
    paddingLeft: '1.5rem',
    backgroundColor: '#FFFFFF',
    fontSize: '1rem'
  },
  searchInputLocation: {
    height: '40px',
    paddingLeft: '1.5rem',
    borderLeft: '1px solid #979797'
  },
  searchButton: {
    width: '3.25rem',
    height: '2.5rem',
    borderRadius: 0,
    borderTopRightRadius: '1.25rem',
    borderBottomRightRadius: '1.25rem',
    backgroundColor: '#73AB38',
    '&:hover': {
      backgroundColor: '#73AB38'
    }
  },
  input: {
    '&::placeholder': {
      color: '#313131',
      letterSpacing: '0.13px',
      lineHeight: '1.5rem',
      [theme.breakpoints.up('sm')]: {
        fontSize: '0.875rem'
      },
      [theme.breakpoints.down('xs')]: {
        fontSize: '0.625rem'
      }
    }
  },
  tooltip: {
    backgroundColor: '#FFFFFF',
    border: '1px solid #979797',
    borderRadius: 0,
    fontSize: '0.75rem',
    letterSpacing: '0.11px',
    lineHeight: '0.938rem',
    padding: '0.6875rem 0.938rem',
    textAlign: 'left',
    width: '17rem'
  },
  tooltipTop: {
    marginBottom: '0.5rem'
  },
  tooltipBottom: {
    marginTop: '0.5rem'
  },
  // tooltipArrow: {
  //   color: '#FFFFFF',
  //   '&::before': {
  //     border: '3px solid blue',
  //     // backgroundColor: '#fff',
  //     boxSizing: 'border-box'
  //   }
  // },
  tooltipRef: {
    marginLeft: '5px',
    width: '80px',
    height: '0.1px',
    backgroundColor: '#EFEFEF'
  }
}));

export default useStyles;
